import { styled } from '@mui/material/styles';

export const SkipContentLink = styled('a', { skipSx: true })(({ theme }) => ({
  left: '50%',
  position: 'absolute',
  transform: 'translateY(-100%)',
  transition: 'transform 0.3s',
  marginLeft: '-4.84375rem',
  padding: theme.spacing(1),
  '&:focus': {
    transform: 'translateY(0%)',
  },
}));
